import { EuiFlyout, EuiFlyoutProps } from '@elastic/eui'
import { useCallback, useEffect, useRef } from 'react'

const AcFlyout = ({ onClose, children, ...rest }: EuiFlyoutProps) => {
  const pointerDownInsideRef = useRef(false)
  const pointerUpInsideRef = useRef(false)
  const closingViaKeyboardRef = useRef(false)

  useEffect(() => {
    const insideFlyout = (e: Event) => !!(e.target as HTMLElement).closest?.('.euiFlyout')
    const handlePointerDown = (e: PointerEvent) => {
      pointerDownInsideRef.current = insideFlyout(e)
    }
    const handlePointerUp = (e: PointerEvent) => {
      pointerUpInsideRef.current = insideFlyout(e)
    }
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closingViaKeyboardRef.current = true
        requestAnimationFrame(() => {
          closingViaKeyboardRef.current = false
        })
      }
    }
    document.addEventListener('pointerdown', handlePointerDown, true)
    document.addEventListener('pointerup', handlePointerUp, true)
    document.addEventListener('keydown', handleKeyDown, true)
    return () => {
      document.removeEventListener('pointerdown', handlePointerDown, true)
      document.removeEventListener('pointerup', handlePointerUp, true)
      document.removeEventListener('keydown', handleKeyDown, true)
    }
  }, [])

  const handleClose: typeof onClose = useCallback((...args) => {
    if (closingViaKeyboardRef.current) {
      onClose(...args)
      return
    }
    if (pointerDownInsideRef.current && !pointerUpInsideRef.current) {
      return
    }
    onClose(...args)
  }, [onClose])

  return (
    <EuiFlyout onClose={handleClose} {...rest}>
      {children}
    </EuiFlyout>
  )
}

export default AcFlyout
